export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8027.d9f44820.jpg";